import React, { useState, useRef, useEffect } from 'react';
import cN from 'classnames';
import styles from './styles.module.scss';
import { Modal, Dialog } from '@lion-design/core';
import { useMediaQuery } from 'react-responsive';
import Icon from '@lion-design/icons';
// import fullScopeStyles from '../../searchResultCards/styles.module.scss'


interface I_BubbleBoxProps {
    content: React.ReactNode;
    children: React.ReactNode;
    bubbleWidth?: number;
    style?: React.CSSProperties;
}

const BubbleBox = ({ content, children, bubbleWidth = 300, style = {} }: I_BubbleBoxProps) => {
    const bodyRef = useRef<HTMLDivElement>(null);
    const [containerLeft, setContainerLeft] = useState<number>(0);
    const [isActive, setIsActive] = useState<boolean>(false);
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    useEffect(() => {
        const width = bodyRef!.current!.offsetWidth;
        setContainerLeft(width);
    }, [bodyRef?.current?.offsetWidth]);


    return (
        <>
            <span
                className={cN(styles.container, 'BubbleBox', { [`${styles.active}`]: isActive })}
                ref={bodyRef}
                // M版不需要onMouseLeave事件，onMouseLeave會影響M版時的Modal關閉功能
                onMouseLeave={() => !isMobile && setIsActive(false)}
                onMouseEnter={() => setIsActive(true)}
            >
                {children}
                {!isMobile &&
                    <div
                        className={styles.bubbleContent}
                        style={{
                            width: bubbleWidth,
                            ...style
                        }}
                    >
                        {content}
                    </div>
                }
            </span>
            {isMobile &&
                <Modal onClose={() => setIsActive(false)} open={isActive} clickOutside={true} width={300} >
                    <div className={styles.mobileContent} >
                        {content}
                    </div>
                </Modal >
            }
        </>

    );
};

export default BubbleBox;
